import { useMemo } from 'react';
import { clsx } from 'clsx';
import { fToCurrency, getInventoryArticleType } from '@web/utils';
import { OrderItem } from '@/store/types';

interface CartItemProps {
  article: OrderItem;
}

const CartItem = (props: CartItemProps) => {
  const article = props.article;
  const itemType = getInventoryArticleType(article);
  const cartQuantity = article.quantity || 0;

  const displayCartQuantity = useMemo(() => {
    if (itemType === 'singular') {
      return cartQuantity;
    }
    if (itemType === 'countable') {
      return `${(article.amount || 1) * cartQuantity} ${article.unit}`;
    }
    if (itemType === 'loose' && article.amount) {
      return `${cartQuantity * article.amount} ${article.unit}`;
    }
    return null;
  }, [article, itemType, cartQuantity]);

  return (
    <div
      className={clsx(
        'border-b border-secondary-grey mb-1-0 last:mb-0 last:border-0 min-h-[8.5rem]',
      )}
    >
      <div className="flex items-center justify-between mb-1-0 md:mb-0-5">
        <p className="text-body1 font-bd">{displayCartQuantity}</p>
      </div>
      <div className="flex justify-between mb-4-0 md:mb-2-0 items-end">
        <div>
          <p className="text-body1 font-bd md:text-1-4 md:w-2/3">
            {article.name}
          </p>
        </div>
        <p className="text-2-5 md:text-2-0 font-bd">
          {fToCurrency(article.price || 0 * (article.quantity || 1))}
        </p>
      </div>
    </div>
  );
};

export default CartItem;
